import type { GetStaticPaths, GetStaticProps, NextPage } from 'next'
import React, { useEffect } from 'react';
import ErrorComponent from '../../components/ErrorComponent';
import { MetaTagsComp } from '../../components/MetaTagsComp';
import StudyDestination from '../../components/StudyDestination';
import fetchUtil from '../../utils/fetchUtil';
import { CACHE_REVALIDATE_24H } from '../../utils/constants';

const StudyDestinations: NextPage = (props: any) => {
  if (!props.countryData || props.countryData.length === 0) {
    return <ErrorComponent />
  }
  useEffect(() => {
    const customStyle = document.documentElement.style
    customStyle.setProperty('--navbar-color', '#6C48F0');
    customStyle.setProperty('--navbar-menu-color', '#ffffff')
  }, [])
  return (
    <>
      {props.countryData?.length > 0 && <MetaTagsComp {...props.countryData[0].meta} />}
      <StudyDestination {...props} />
    </>
  )
}

export const getStaticPaths: GetStaticPaths = async () => {
  return { paths: [], fallback: 'blocking' };
}

export const getStaticProps: GetStaticProps = async (context) => {
  // Wrap CMS calls so a failed/forbidden response (e.g. 403) falls back to a
  // safe default instead of throwing and breaking the build/page.
  const safeFetch = async <T,>(url: string, fallback: T): Promise<T> => {
    try {
      return (await fetchUtil(url, 'GET', {}, '', false)) as T
    } catch (error) {
      return fallback
    }
  }

  const pageData = await safeFetch<any>(`${process.env.NEXT_PUBLIC_API_BASE_URL}/study-destinations-landing`, {})
  const countryData = await safeFetch<any>(`${process.env.NEXT_PUBLIC_API_BASE_URL}/study-countries-others?slug=${context.params?.slug}`, [])
  return {
    props: { pageData, countryData },
    revalidate: CACHE_REVALIDATE_24H,
  };
}

export default StudyDestinations;